<script setup lang="ts">
defineProps<{
  media?: boolean
}>()
</script>
<template>
  <div :class="[media ? 'message-bottom-media' : 'message-bottom']">
    <slot />
  </div>
</template>
<style lang="css" scoped>
.message-bottom {
  @apply tw-flex tw-justify-end tw-items-center tw-gap-2 tw-relative tw-mr-0 tw-mb-[-5px] tw-mt-[-2px];
}

.message-bottom-media {
  @apply tw-inline-flex tw-items-center tw-gap-2 tw-relative tw-right-1 tw-float-right tw-top-2;
}
</style>
